import { render, staticRenderFns } from "./profileSidebar.vue?vue&type=template&id=51c909c7&"
import script from "./profileSidebar.vue?vue&type=script&lang=js&"
export * from "./profileSidebar.vue?vue&type=script&lang=js&"
import style0 from "./profileSidebar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports